<template>
  <f-data-table id="manage-releases-table"
                :expanded="true"
                heading="Releases"
                icon=""
                :data-uri="data_uri"
                :columns="columns"
                :selectable-rows="false"
                :server-side="true">
    <template slot="_actions">
      <div class="kt-portlet__head-toolbar">
        <div class="kt-portlet__head-wrapper">
          <a type="button" class="btn btn-ss-standout btn-icon-sm" href="/admin/releases/create/">
            <i class="flaticon2-plus" />New Release
          </a>
        </div>
      </div>
    </template>

    <template slot="actions" slot-scope="props">
      <div class="row-action-cell">
        <div class="dropdown dropdown-inline">
          <button type="button" class="btn btn-clean btn-icon"
                  data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
            <i class="flaticon-more-1" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" style="">
            <ul class="kt-nav">
              <li class="kt-nav__item">
                <a :href="`/admin/releases/${props.row.id}/edit`" class="kt-nav__link">
                  <span class="kt-nav__link-text">Edit</span>
                </a>
              </li>
              <li class="kt-nav__item">
                <a href="javascript:;" class="kt-nav__link" @click="togglePublish(props.row)">
                  <span v-if="props.row.published" class="kt-nav__link-text">Unpublish</span>
                  <span v-else class="kt-nav__link-text">Publish</span>
                </a>
              </li>
              <li class="kt-nav__item">
                <a href="javascript:;" class="kt-nav__link" @click="deleteRelease(props.row)">
                  <span class="kt-nav__link-text">Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>

    <template slot="name" slot-scope="props">
      <a :href="`/admin/releases/${props.row.id}/edit`" target="_blank">{{ props.value }}</a>
    </template>

    <template slot="published" slot-scope="props">
      {{ props.value ? 'Yes' : 'No' }}
    </template>
  </f-data-table>
</template>
<script>

import FDataTable from "VuePartials/App/Storage/FDataTable/FDataTable";

export default {
  components: { FDataTable },
  data() {
    return {
      data_uri: '/api/v1/releases',
      columns: [
        {
          display: "Name",
          field: "name",
          never_clip: true,
        },
        {
          display: "Published",
          field: "published",
        },
        {
          display: "Release Date",
          field: 'release_date',
          active_sort: true,
          sort_dir: `desc`,
          sortable: true,
        },
        {
          field: `actions`,
          display: ``,
          sortable: false,
          width: 150,
          never_clip: true,
        },
      ],
    };
  },
  methods: {
    togglePublish(release) {
      axios.patch(`/api/v1/admin/releases/${release.id}/toggle-publish`).then(() => {
        const status = release.published ? 'Release Unpublished' : 'Release Published';
        toastr.success(status);
        EventBus.$emit('manage-releases-table-reload');
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
    deleteRelease(release) {
      axios.delete(`/api/v1/admin/releases/${release.id}`).then(() => {
        toastr.success("release deleted");
        EventBus.$emit('manage-releases-table-reload');
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
  },
};
</script>
